var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.getters.currentItemVariation
    ? _c(
        "div",
        { staticClass: "single__vat", on: { click: _vm.toggleSidebar } },
        [
          _c(
            "span",
            [
              _vm.inclShipping ? [_vm._v("inkl.")] : [_vm._v("zzgl.")],
              _vm._v(" "),
              _c("u", [_vm._v("Versandkosten")])
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }